import { render, staticRenderFns } from "./LegalExpertUsers.vue?vue&type=template&id=0a4b13e7&scoped=true"
import script from "./LegalExpertUsers.vue?vue&type=script&lang=js"
export * from "./LegalExpertUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4b13e7",
  null
  
)

export default component.exports